import { render, staticRenderFns } from "./DeletePlanDialog.vue?vue&type=template&id=0bad19ac&"
import script from "./DeletePlanDialog.vue?vue&type=script&lang=ts&"
export * from "./DeletePlanDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports